import styled, { keyframes } from 'styled-components'
import { G, PC_HEADER_H, PC_WIDTH } from '@/components/gold/theme'

/** ver2(gold) 메인 바탕 — 고정 헤더 높이만큼 위를 비운다 */
export const Page = styled.div`
  min-height: 100vh;
  padding-top: ${PC_HEADER_H + 1}px;
  background: ${G.bg};
`

/** 공지 띠·타일 영역 — 원본 1200px × 1.2 */
export const Body = styled.div`
  width: ${PC_WIDTH}px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  padding-top: 55px;
`

/** 원본 .homePage: 위 30·아래 400(× 1.2) — 타일 아래 넓은 여백까지 그대로 */
export const HomeGrid = styled.div`
  padding: 36px 0 480px;
`

/** grand-edit `main.html` — 배너·본문은 `.content-area` 안 (헤더는 밖)
 *  섹션 간격(배너·슬롯알림·벤더리스트·푸터)은 자식의 margin 합산이 아니라 여기서 한 번에 정한다.
 *  ⚠️ flex 로 바꾸면 .container/.banner 의 폭 제약이 무너져 배너·게임카드가 화면 끝까지 늘어난다.
 *     블록 레이아웃을 유지한 채 인접 형제에 위쪽 여백만 준다. */
export const ContentArea = styled.div.attrs({
  className: 'content-area',
})`
  && > * + * {
    margin-top: var(--section-gap, 40px);
  }
`

const scrollAnim = keyframes`
  0%   { transform: translateX(100vw); }
  100% { transform: translateX(-100%); }
`

/** 점검 예약 스크롤 공지 (하단 고정) */
export const ScrollNotice = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: #f5a623;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  padding: 8px 0;
  z-index: 9999;
`

export const ScrollNoticeTrack = styled.span`
  display: inline-block;
  animation: ${scrollAnim} 20s linear infinite;
`
